import { observable, action, computed } from "mobx";

export const Delay = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

export enum StoreStatus {
    PENDING,
    LOADING,
    ERROR,
    READY
}

export interface BaseStoreStatus {
    status: StoreStatus;
    latestErrorMessage: string;
}

export class BaseStore {
    @observable protected baseStoreStatus: BaseStoreStatus = {
        status: StoreStatus.PENDING,
        latestErrorMessage: ""
    };

    @action protected setLoading() {
        this.baseStoreStatus.status = StoreStatus.LOADING;
    }

    @action protected setReady() {
        this.baseStoreStatus.status = StoreStatus.READY;
    }

    @action protected setError(message: string = "") {
        this.baseStoreStatus.status = StoreStatus.ERROR;
        this.baseStoreStatus.latestErrorMessage = message;
    }

    @computed get pending() {
        return this.baseStoreStatus.status === StoreStatus.PENDING;
    }

    @computed get loading() {
        return this.baseStoreStatus.status === StoreStatus.LOADING;
    }

    @computed get ready() {
        return this.baseStoreStatus.status === StoreStatus.READY;
    }

    @computed get error() {
        return this.baseStoreStatus.status === StoreStatus.ERROR;
    }

    @computed get latestErrorMessage(): string {
        return this.baseStoreStatus.latestErrorMessage;
    }
}



// WEBPACK FOOTER //
// ./src/stores/BaseStore.ts